export default __webpack_public_path__ + "static/media/Jal-Mahotsav.476ed433.jpg";